<template>
  <span>
    <el-popover placement="bottom-start" width="700" trigger="click">
      <div style="height: 300px">
        <el-scrollbar>
          <div class="title-h4 title-bar">최근 재부팅 사유</div>
          <div v-for="item in resetList" :key="item.keyword">
            <div class="title-bar dot-title" style="font-weight: 700;">{{item.keyword}}</div>
            {{item.desc}}
            <br /><br />
          </div>
        </el-scrollbar>
      </div>
      <el-button slot="reference">도움말</el-button>
      <!-- <i slot="reference" class="el-icon-info"></i> -->
    </el-popover>
  </span>
</template>

<script>
export default {
  name: 'WDeviceConfigHelpButton',
  data() {
    return {
      resetList: [
        {
          keyword: 'Address Error',
          desc: '주소 오류는 소프트웨어가 boundary.2바이트를 제대로 정렬하지 않고 데이터에 접속하려던 때에 발생합니다.4바이트의 액세스는,' +
            '짝수 주소로만 허용됩니다. 주소 에러는 통상적으로 소프트웨어의 불량을 나타내지만, 하드웨어 장해에 의해서도 발생하는 경우가 있습니다',
        },
        {
          keyword: 'Arithmetic Exception',
          desc: '통상적으로 소프트웨어의 문제가 원인으로 해당 에러가 발생합니다.',
        },
        {
          keyword: 'Cache Error Exception',
          desc: '라우터가 불량 패리티를 검출했을 때 발생합니다. 이 문제는 일시적인 문제이거나, 하드웨어 장애 중 하나입니다.',
        },
        {
          keyword: 'Error - Level <x>',
          desc: '하드웨어와 관련되어 있습니다. 대부분의 경우, CPU 보드에 문제가 있으면, 해당 에러가 발생합니다.',
        },
        {
          keyword: 'Error Interrupt',
          desc: '프로세서 이외의 무언가가 치명적인 에러를 검출한 것을 나타냅니다. 근본적인 원인을 특정하기 위해서는 더 많은 정보가 필요합니다. 트러블 슈팅에는 crashinfo 파일 또는 show tech-support 명령어의 출력이 필요합니다.',
        },
        {
          keyword: 'Format Error',
          desc: '해당 에러는 하드웨어의 문제를 나타내고 있는 경우입니다.',
        },
        {
          keyword: 'Illegal Instruction',
          desc: '해당 에러는 대부분의 경우 소프트웨어에 관련되어 있습니다. 다만, 하드웨어 장애로 인해 이 문제가 발생할 수도 있습니다(통상은 플래시 메모리 또는 D램의 장애). 이 문제는, Cisco IOS 소프트웨어 이미지의 파손에 의해서도 발생할 가능성이 있습니다.',
        },
        {
          keyword: 'Illegal Opcode Exception',
          desc: '해당 에러는 하드웨어 장애로 인해 발생합니다(CPU 보드의 장애 등). 경우에 따라서는, 소프트웨어의 문제로 이 에러가 발생할 수 있습니다',
        },
        {
          keyword: 'Jump to Zero Error',
          desc: '해당 에러는 Cisco IOS 소프트웨어가 코드가 아닌 데이터를 실행하려고 했을 때에 발생하는 경우가 자주 있습니다. 대부분의 경우, 소프트웨어의 불량품에 의해서 이 문제가 발생합니다만, 증상이 분명히 하드웨어 장해를 나타내고 있는 경우는 CPU에 장해가 있을 가능성을 검토해 주세요',
        },
        {
          keyword: 'Line Emulator Trap',
          desc: '프로세서가 무효인 명령을 실행하려고 할 때 회선 1010/1111에뮬레이터 에러가 발생합니다. 코드 1010/1111은, 별로 관련성이 없습니다',
        },
        {
          keyword: 'Power-On',
          desc: 'show version 커멘드의 출력이 리로드에 의해서 재기동되는지, 또는 전원투입에 의해서 시스템이 ROM 로 돌아올 경우, 라우터의 전원이 재투입되었는지, 전원이 몇 초간 다운되었는지 알 수 있습니다. 전원을 확인하고 콘센트 회로(라우터의 전원간)의 트러블 슈팅을 실시해야합니다.',
        },
        {
          keyword: 'Reload',
          desc: 'show version 명령어의 출력이 리로드에 의해 재부팅 되거나 시스템이 리로드에 의해 ROM으로 되돌아갔다고 표시되었을 경우에는'
            + 'reload 명령어를 사용하여 사용자가 라우터를 수동으로 리부트했다고 추측할 수 있습니다. 이것은 시스템 크러쉬가 아닙니다.',
        },
        {
          keyword: 'Reserved Exception',
          desc: '이 타입의 크러쉬에서는 라우터가 파손된 데이터를 송신하지 않도록 리로드가 발생합니다. 원인은 하드웨어 관련 또는 소프트웨어 관련 중 하나입니다.',
        },
        {
          keyword: 'Restarted By Error',
          desc: '오류가 명백히 하드웨어의 문제를 나타내는 경우입니다.',
        },
        {
          keyword: 'Sigtrap (Signal Trap) Exception',
          desc: '보통은 소프트웨어 문제입니다.',
        },
        {
          keyword: 'Undefined Trap',
          desc: '명확하지않은 장애가 발생하였습니다.',
        },
        {
          keyword: 'Unexpected Hardware Interrupt',
          desc: '통상적으로 하드웨어의 문제에 의해서 이 타입의 크러쉬가 발생합니다.',
        },
        {
          keyword: 'Unknown Failure',
          desc: '명확하지않은 장애가 발생하였습니다.',
        },
        {
          keyword: 'Unknown Reload Cause',
          desc: '여기에서는, 크러쉬의 원인이 된 장해에 의해, 라우터는 리로드 이유를 기록할 수 없습니다. 이 문제는 하드웨어 또는 소프트웨어에 관련된 경우가 있습니다.'
            + '사용하신 릴리스 트레인 최신 Cisco IOS 소프트웨어 버전으로 업그레이드함으로써 이 불량을 해결할 수 있는지 여부를 확인합니다. ',
        },
        {
          keyword: 'Write Bus Error Interrupt',
          desc: '통상적으로 하드웨어의 문제에 의해서 이 타입의 크러쉬가 발생합니다.',
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/DeviceConfigHelpButton.vue